// config.js用来存放一些公共的参数 例如我们请求的api地址

export default {
    bashUrl: "https://api.haofang0375.cn/manager",
    domain: "https://api.haofang0375.cn"
}